'use strict';

var IS_PURE = require('../internals/is-pure');

var global = require('../internals/global');

var fails = require('../internals/fails');

var WEBKIT = require('../internals/engine-webkit-version'); // Forced replacement object prototype accessors methods


module.exports = IS_PURE || !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random(); // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call, es-x/no-legacy-object-prototype-accessor-methods -- required for testing

  __defineSetter__.call(null, key, function () {
    /* empty */
  });

  delete global[key];
});